<div class="er-dialog-dark er-matdark">
<mat-card>
    <mat-card-header style="text-align: center;">
        <img [src]="ymLogoPng" style="width: 80px;margin: auto;
        margin-bottom: 3%;">
    </mat-card-header>
    <mat-card-title style="text-align: center;">
        <h6>{{data.senderDetails.message}}</h6>
        <h6 style="color: #016F34;">Name: {{data.senderDetails.object.dmtimpsDetails[0].beneficiaryName}}</h6>
        <h6 style="color: #016F34;">A/C No.:{{data.senderDetails.object.dmtimpsDetails[0].beneficiaryAccountNumber}}
        </h6>

    </mat-card-title>
    <mat-card-content>
        <h3>{{data.Port}}</h3>
        <div style="text-align: center;">
            <h6> Download Receipt</h6>
            <img src="../../../assets/images/file_pdf_download_icon.svg"
                (click)="downloadPdf(data.senderDetails.object.transactionReference,'')" style="width: 50px;cursor: pointer;"><br>

            <h6>Share Receipt</h6>

            <share-button button="whatsapp" [showText]="true"  (click)="downloadPdf(data.senderDetails.object.transactionReference,'whatsapp')" [url]="pdfUrlWhatsapp"
                [title]="'DMT Transaction Receipt'" [description]="'Receipt'" [tags]="'DMT'">
            </share-button>

        </div>
    </mat-card-content>
    <mat-card-actions style="text-align: center;">
        <button mat-raised-button color="primary" (click)='cancel()'>Cancel</button>
    </mat-card-actions>
</mat-card>
</div>
